export default __webpack_public_path__ + "static/media/placeholder_business04-es-web.9a9ada55.png";